import { render, staticRenderFns } from "./QuizQuestionCard.vue?vue&type=template&id=07f55b13&scoped=true"
import script from "./QuizQuestionCard.vue?vue&type=script&lang=js"
export * from "./QuizQuestionCard.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestionCard.vue?vue&type=style&index=0&id=07f55b13&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f55b13",
  null
  
)

export default component.exports